function SellUpload() {
  return null;
}

export default SellUpload;
